<script>
import utils from "@/services/utils";

export default {
    name: "MessageContent",
    props: {
        content: Object,
        isUser: null,
        isBot: null,
        chatlog_id: String,
        isChatWithAgent: null,
        react_icon: null,
        isDeleted: null,
        showReplyButton: null,
        quoteProps:null,
    },
    data () {
        const textMaxLength = 200
        return {
            showViewMore: true,
            // temporary hide
            // needViewMore: this.content.text ? this.content.text.length > textMaxLength : false,
            needViewMore: false,
            textMaxLength: textMaxLength,
            imageError: false
        }
    },
    methods: {
        replaceLinkInTextContent (content) {
            if (!content) {
                return ''
            }
            if (this.needViewMore && this.showViewMore && content.length > this.textMaxLength) {
                content = content.substring(0, this.textMaxLength) + '...'
            }
            return utils.urlify(content)
        },
        canNotLoadImage () {
            this.imageError = true
        }
    }
}
</script>
<style lang="scss" scoped src="../../style/message-box.scss">

</style>
